module.exports = __webpack_public_path__ + "img/Avatar-14.24ce0d49.svg";